const colors = [
  '#ffd700',
  '#adff2f',
  '#ff00ff',
  '#0000ff',
  '#7f007f',
  '#4682b4',
  '#dc143c',
  '#add8e6',
  '#00008b',
  '#daa520',
  '#696969',
  '#ff4500',
  '#8b4513',
  '#808000',
  '#483d8b',
  '#008000',
  '#3cb371',
  '#bc8f8f',
  '#00ff7f',
  '#008080',
  '#9acd32',
  '#8fbc8f',
  '#b03060',
  '#00ced1',
  '#ff8c00',
  '#00ff00',
  '#8a2be2',
  '#00bfff',
  '#9370db',
  '#f08080',
  '#1e90ff',
  '#f0e68c',
  '#556b2f',
  '#dda0dd',
  '#ee82ee',
  '#7fffd4',
  '#ff69b4',
  '#8b0000',
  '#98fb98',
  '#f4a460',
];

export { colors };
